module.exports = __webpack_public_path__ + "frontend/images/white/carousel/static/traveling@2.png?d06c7fa6c961f59234f5db459ac58754";